import { render, staticRenderFns } from "./endereco-component.vue?vue&type=template&id=e1c50436&"
import script from "./endereco-component.vue?vue&type=script&lang=ts&"
export * from "./endereco-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1c50436')) {
      api.createRecord('e1c50436', component.options)
    } else {
      api.reload('e1c50436', component.options)
    }
    module.hot.accept("./endereco-component.vue?vue&type=template&id=e1c50436&", function () {
      api.rerender('e1c50436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/endereco-component.vue"
export default component.exports